import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { useCountdown } from '../hooks/useCountdown';
import { useGeoPricing } from '../hooks/useGeoPricing';
export function PricingSection() {
  const {
    minutes,
    seconds
  } = useCountdown(15);
  const {
    currentPrice,
    comparePrice,
    isLoading
  } = useGeoPricing();
  return <section className="py-4 bg-slate-950 flex justify-center px-4" data-id="element-84">
      <div className="w-full max-w-xl flex flex-col items-center" data-id="element-85">
        <div className="w-full mb-3 relative" data-id="element-86">
          <div className="absolute inset-0 bg-orange-500/20 blur-3xl rounded-full" data-id="element-87"></div>
          <img src="https://cdn.magicpatterns.com/uploads/jtBfkRdfFfVsfhBoftBQ98/unnamed.jpg" alt="Sistema Maestro de Herrería" className="w-full h-auto rounded-xl relative z-10 object-cover" data-id="element-88" />
        </div>
        <div className="w-full text-left space-y-2" data-id="element-89">
          <p className="text-[10px] font-bold text-slate-400 tracking-wider uppercase" data-id="element-90">
            +1000 DESCARGAS
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white uppercase leading-tight" data-id="element-91">
            SISTEMA MAESTRO DE HERRERÍA™ + 8 BONUS DE REGALO
          </h2>
          <div className="flex flex-wrap items-center gap-3 pt-1" data-id="element-92">
            <span className={`text-slate-400 line-through font-medium text-lg transition-opacity ${isLoading ? 'opacity-0' : 'opacity-100'}`} data-id="element-93">
              {comparePrice}
            </span>
            <span className={`text-white font-bold text-2xl transition-opacity ${isLoading ? 'opacity-0' : 'opacity-100'}`} data-id="element-94">
              {currentPrice}
            </span>
            <div className="bg-black border border-yellow-500/30 rounded-full px-3 py-1 flex items-center" data-id="element-95">
              <span className="text-yellow-500 text-xs font-bold tracking-wide" data-id="element-96">
                🎁 Oferta +50% OFF solo 20 cupos
              </span>
            </div>
          </div>
          <p className="text-xs text-slate-500 font-medium" data-id="element-97">
            Impuestos incluidos.
          </p>
          <div className="w-full bg-red-600 rounded-lg py-2.5 flex items-center justify-center" data-id="element-98">
            <div className="w-3 h-3 bg-white rounded-full mr-2 animate-pulse" data-id="element-99"></div>
            <span className="text-white font-bold text-sm tracking-wide" data-id="element-100">
              ¡Últimos cupos disponibles!
            </span>
          </div>
          <div className="w-full pt-1" data-id="element-101">
            <CTAButton className="w-full !bg-green-600 hover:!bg-green-500 focus:ring-green-500/50 shadow-[0_0_20px_rgba(22,163,74,0.4)]" data-id="element-102">
              ¡QUIERO MI CAMBIO!
            </CTAButton>
          </div>
          <div className="w-full bg-[#7a0000] border border-red-800 rounded-xl p-4 mt-3 flex flex-col items-center text-center" data-id="element-103">
            <h3 className="text-white font-heading font-bold text-lg md:text-xl uppercase mb-1 tracking-wide" data-id="element-104">
              OFERTA{' '}
              <span className="underline decoration-2 underline-offset-4" data-id="element-105">
                SOLO POR HOY
              </span>{' '}
              !!!
            </h3>
            <p className="text-white font-medium text-sm mb-1" data-id="element-106">
              Reserva válida por <span className="font-bold" data-id="element-107">15 minutos.</span>
            </p>
            <p className="text-white/90 italic text-sm mb-4" data-id="element-108">
              Si no accedés,{' '}
              <span className="font-bold" data-id="element-109">
                tu descuento pasa a la siguiente persona.
              </span>
            </p>
            <div className="flex flex-col items-center" data-id="element-110">
              <div className="text-4xl md:text-5xl font-heading font-bold text-white tracking-widest flex items-center justify-center w-full" data-id="element-111">
                <span data-id="element-112">{minutes}</span>
                <span className="mx-2 -translate-y-1" data-id="element-113">:</span>
                <span data-id="element-114">{seconds}</span>
              </div>
              <div className="flex justify-between w-[120px] md:w-[150px] mt-1" data-id="element-115">
                <span className="text-[10px] md:text-xs text-white/80 font-bold uppercase tracking-wider" data-id="element-116">
                  Minutos
                </span>
                <span className="text-[10px] md:text-xs text-white/80 font-bold uppercase tracking-wider" data-id="element-117">
                  Segundos
                </span>
              </div>
            </div>
          </div>
          <div className="w-full flex items-center justify-center pt-1 pb-20" data-id="element-118">
            <div className="w-2 h-2 bg-red-600 rounded-full mr-2 animate-pulse" data-id="element-119"></div>
            <span className="text-red-600 font-bold text-xs tracking-widest uppercase" data-id="element-120">
              STOCK BAJO
            </span>
          </div>
        </div>
      </div>
    </section>;
}